import { Reducer } from 'redux';
import {
    GetMailchimpConnectionParamsAction,
    SetMailchimpConnectionParamsAction,
    GetMailchimpListsAction,
    SetMailchimpListsAction,
    IntegrationsState,
    IntegrationsActionTypes,
    SetMailchimpListMembersProgressAction,
} from './types';

const defaultState: IntegrationsState = {
    mailchimp: {
        connection: null,
        lists: {
            data: [],
            paginationParams: {
                offset: 0,
                count: 0,
            },
            total: 0,
            isLoading: false,
            isLoaded: false,
        },
        listMembers: {
            progressPercent: 0,
            isLoading: false,
            isLoaded: false,
        },
    },
};

const getMailchimpConnectionParams = (
    state: IntegrationsState,
    action: GetMailchimpConnectionParamsAction
): IntegrationsState => ({
    ...state,
    mailchimp: {
        ...state.mailchimp,
        connection: { tempCode: action.payload.tempCode },
    },
});

const setMailchimpConnectionParams = (
    state: IntegrationsState,
    action: SetMailchimpConnectionParamsAction
): IntegrationsState => ({
    ...state,
    mailchimp: {
        ...state.mailchimp,
        connection: action.payload,
    },
});

const getMailchimpLists = (state: IntegrationsState, action: GetMailchimpListsAction): IntegrationsState => ({
    ...state,
    mailchimp: {
        ...state.mailchimp,
        lists: {
            ...state.mailchimp.lists,
            isLoading: true,
            ...(action.payload.offset === 0 ? { isLoaded: false } : {}),
        },
    },
});

const setMailchimpLists = (state: IntegrationsState, action: SetMailchimpListsAction): IntegrationsState => ({
    ...state,
    mailchimp: {
        ...state.mailchimp,
        lists: {
            ...state.mailchimp.lists,
            ...action.payload,
            isLoading: false,
            isLoaded: true,
        },
        listMembers: {
            progressPercent: 0,
            isLoading: false,
            isLoaded: false,
        },
    },
});

const setMailchimpListMembersProgress = (
    state: IntegrationsState,
    action: SetMailchimpListMembersProgressAction
): IntegrationsState => ({
    ...state,
    mailchimp: {
        ...state.mailchimp,
        listMembers: {
            progressPercent: action.payload,
            isLoading: action.payload > 0 && action.payload < 100,
            isLoaded: action.payload === 100,
        },
    },
});

const reducer: Reducer<IntegrationsState> = (state: IntegrationsState = defaultState, action): IntegrationsState => {
    switch (action.type) {
        case IntegrationsActionTypes.GET_MAILCHIMP_CONNECTION_PARAMS:
            return getMailchimpConnectionParams(state, action as GetMailchimpConnectionParamsAction);
        case IntegrationsActionTypes.SET_MAILCHIMP_CONNECTION_PARAMS:
            return setMailchimpConnectionParams(state, action as SetMailchimpConnectionParamsAction);
        case IntegrationsActionTypes.GET_MAILCHIMP_LISTS:
            return getMailchimpLists(state, action as GetMailchimpListsAction);
        case IntegrationsActionTypes.SET_MAILCHIMP_LISTS:
            return setMailchimpLists(state, action as SetMailchimpListsAction);
        case IntegrationsActionTypes.SET_MAILCHIMP_LIST_MEMBERS_PROGRESS:
            return setMailchimpListMembersProgress(state, action as SetMailchimpListMembersProgressAction);
        default:
            return state;
    }
};

export { reducer as integrations };

export default reducer;
